export default "<app-header></app-header>\r\n";